import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const DocumentSharePointUpload = () => {
    useBrowserTabTitle('Document SharePoint Upload')
    return (
        <SharePointUpload
            entityType="Document"
            apiPath="documents"
            statusField="document_status"
        />
    )
};

export default DocumentSharePointUpload
